export type WeatherIcon =
  | 'clear-day'
  | 'clear-night'
  | 'partly-cloudy-day'
  | 'partly-cloudy-night'
  | 'cloudy'
  | 'fog'
  | 'rain'
  | 'snow'
  | 'thunderstorm';

/**
 * Weather captured at the moment a tone response was resolved.
 * `requestId` maps to `UserRequest.id`.
 */
export interface ToneResponseWeather {
  requestId: number;
  temperature_f: number;
  temperature_c: number;
  feels_like_f: number;
  feels_like_c: number;
  humidity_percent: number;
  precipitation_in: number;
  rain_in?: number;
  showers_in?: number;
  snowfall_in?: number;
  wind_speed_mph: number;
  wind_direction_deg?: number;
  wind_gusts_mph?: number;
  cloud_cover_percent?: number;
  pressure_msl_hpa?: number;
  surface_pressure_hpa?: number;
  is_day: boolean;
  weather_code: number;
  condition: string;
  icon: WeatherIcon;
  fetched_at: string;
}

export interface ToneResponseWeatherResponse {
  data: ToneResponseWeather[];
}

/** Mirrors MAX_WEATHER_REQUEST_IDS on the backend. */
export const MAX_WEATHER_REQUEST_IDS = 200;
